import BOMDetails from './BOMDetails';
import BOMProducedHistory from './BOMHistory';

const ViewLayout = {
    main: BOMDetails,
    history: BOMProducedHistory
}

export default ViewLayout;